import { schema } from 'normalizr';

const busGoShowBookingFormSchema = new schema.Entity(
  'busGoShowBookingForm',
  {},
  {
    idAttribute: value => `${value.routeId}`,
  }
);

export default busGoShowBookingFormSchema;
